import React from "react";
import {
  HomeWrapper,
  VideoBg,
  VideoWrapper,
  VideoMsg,
  ScrollIcon,
  ProjectsWrapper,
  PeopleWrapper,
  ContactWrapper,
  ContactCard,
  ContactTextWrapper,
  ServicesWrapper,
  ServiceCardsWrapper,
  ServiceCard,
} from "./elements";
import { H1 } from "../../components/sharedElements";
import { Corousel2 } from "../../components/corousel";
import homeBgVideo from "../../assets/videos/homeBg.mp4";
import contact from "../../assets/images/contact.jpg";
import ScrollToTop from "../../components/ScrollToTop";

const Home = () => {
  return (
    <div id="topDiv">
      <HomeWrapper>
        <VideoWrapper id="video">
          <VideoBg autoPlay loop muted src={homeBgVideo} type="video/mp4" />
          <VideoMsg>We make places better for generations to come</VideoMsg>
          <ScrollIcon
            to="projects"
            className="fas fa-chevron-down"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
          />
        </VideoWrapper>
        <ProjectsWrapper id="projects">
          <H1>Projects</H1>
          <Corousel2 />
          <ScrollIcon
            to="people"
            className="fas fa-chevron-down"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
          />
        </ProjectsWrapper>
        <PeopleWrapper id="people">
          <H1>People</H1>
          <ScrollIcon
            to="services"
            className="fas fa-chevron-down"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
          />
        </PeopleWrapper>
        <ServicesWrapper id="services">
          <H1>What we do</H1>
          <ServiceCardsWrapper>
            <ServiceCard>
              <img src="images/services/lineplan.jpg" alt="service card" />
              <h1>Architecture</h1>
            </ServiceCard>
            <ServiceCard>
              <img src="images/services/structure.jpg" alt="service card" />
              <h1>Structure</h1>
            </ServiceCard>
            <ServiceCard>
              <img src="images/services/construction.jpg" alt="service card" />
              <h1>Construction</h1>
            </ServiceCard>
            <ServiceCard>
              <img src="images/services/renovation.jpg" alt="service card" />
              <h1>Renovation</h1>
            </ServiceCard>
            <ServiceCard>
              <img src="images/services/furnishing.jpg" alt="service card" />
              <h1>Furnishing</h1>
            </ServiceCard>
          </ServiceCardsWrapper>
        </ServicesWrapper>
        <ContactWrapper id="contact">
          <H1>Contact</H1>
          <ContactCard to="/contactus#top">
            <img src={contact} alt="contact" />
            <ContactTextWrapper>
              <h1>get in touch</h1>
              <p>You'll find all the contact details you need here</p>
              <button type="button">Contact us</button>
            </ContactTextWrapper>
          </ContactCard>
        </ContactWrapper>
      </HomeWrapper>
      <ScrollToTop />
    </div>
  );
};

export default Home;
